import { render } from "./ViewMercadoFailure.vue?vue&type=template&id=980befa4"
import script from "./ViewMercadoFailure.vue?vue&type=script&lang=js"
export * from "./ViewMercadoFailure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__